import React, { FunctionComponent } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { DialogTitle, Typography } from '@material-ui/core';
import { eodItemStyles } from '../../eodItemStyles';

type ErrorProps = {
  eodReportDetails: any;
  updateErrorFlag: boolean;
  updateError: () => void;
};
export const UpdateErrorFlag: FunctionComponent<ErrorProps> = ({
  eodReportDetails,
  updateErrorFlag,
  updateError
}) => {
  const classes = eodItemStyles();

  return (
    <div>
      <Dialog aria-labelledby="customized-dialog-title" open={updateErrorFlag} fullWidth={true}>
        <DialogTitle id="customized-dialog-title" style={{ backgroundColor: "#3d5a79" }}>
          <Typography className={classes.dialogTitleStyle}>
            Confirmation-Dialog
          </Typography>
        </DialogTitle>

        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            <Typography className={classes.errorMessageStyle}>
              {eodReportDetails.error_array[0].message}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              updateError()
            }}>
            OK
            </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
